var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueueCapCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.016L9.6 10.616V16.8C9.6 18.568 11.032 20 12.8 20H17.6C18 20 18.4 19.912 18.752 19.768L20.584 21.6H8V23.2H22.184L22.976 24L24 22.976L9.016 8L8 9.016ZM12.8 18.4C11.92 18.4 11.2 17.68 11.2 16.8V12.216L17.384 18.4H12.8ZM22.4 8.8H11.848L13.448 10.4H19.2V16.152L20.68 17.632C20.752 17.36 20.8 17.088 20.8 16.8V14.4H22.4C23.28 14.4 24 13.68 24 12.8V10.4C24 9.52 23.28 8.8 22.4 8.8ZM22.4 12.8H20.8V10.4H22.4V12.8Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueCapCancel);
export default __webpack_public_path__ + "static/media/queue_cap_cancel.4081083cb1204a6ac70bf04f9a7c0df5.svg";
export { ForwardRef as ReactComponent };